module.exports = __webpack_public_path__ + "assets/img/bld.cba55b99.png";